module.exports = __webpack_public_path__ + "static/Portfolio16-73e9b8267f519daf0f543cad25c74b35.jpg";